(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["app-detail"]) return;
  try {
    
  (function () {
    var thumbs = document.querySelectorAll('.app-detail__thumb');
    if (!thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function (event) {
        var hash = thumb.getAttribute('href');
        if (!hash || hash.charAt(0) !== '#') return;
        var target = document.getElementById(hash.slice(1));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (() => {
    if (!window.matchMedia('(hover: hover)').matches) return;

    document.querySelectorAll('.footer__policies').forEach((policies) => {
      policies.addEventListener('mouseenter', () => {
        policies.open = true;
      });

      policies.addEventListener('mouseleave', () => {
        policies.open = false;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    document.querySelectorAll('.header__mobile-menu').forEach((menu) => {
      if (menu.dataset.mobileMenuInitialized === 'true') return;

      const toggle = menu.querySelector('.header__menu-toggle');
      const panel = menu.querySelector('.header__mobile-menu-panel');
      const icon = menu.querySelector('[data-header-menu-icon]');
      if (!toggle || !panel || !icon) return;

      menu.dataset.mobileMenuInitialized = 'true';

      const setOpen = (open) => {
        menu.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', String(open));
        panel.hidden = !open;
        icon.style.setProperty(
          '--header-material-icon',
          `url("${open ? icon.dataset.closeIcon : icon.dataset.menuIcon}")`
        );
      };

      setOpen(false);

      toggle.addEventListener('click', () => {
        setOpen(toggle.getAttribute('aria-expanded') !== 'true');
      });

      menu.querySelectorAll('.header__mobile-menu-panel a').forEach((link) => {
        link.addEventListener('click', () => setOpen(false));
      });

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || toggle.getAttribute('aria-expanded') !== 'true') return;

        setOpen(false);
        toggle.focus();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-visual"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mainVisuals = document.querySelectorAll('[data-main-visual]');

    mainVisuals.forEach((mainVisual) => {
      const slides = Array.from(mainVisual.querySelectorAll('[data-main-visual-slide]'));
      const details = Array.from(mainVisual.querySelectorAll('[data-main-visual-detail]'));
      const dots = Array.from(mainVisual.querySelectorAll('[data-main-visual-dot]'));
      const playbackToggle = mainVisual.querySelector('[data-main-visual-playback-toggle]');
      const playbackIcon = mainVisual.querySelector('[data-main-visual-playback-icon]');
      const carousel = mainVisual.querySelector('.main-visual__carousel');
      const media = mainVisual.querySelector('.main-visual__media');
      const interval = Number(mainVisual.dataset.slideInterval);

      if (slides.length === 0) {
        return;
      }

      let activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));

      if (activeIndex < 0) {
        activeIndex = 0;
      }

      const setActiveSlide = (index) => {
        activeIndex = index;

        slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === activeIndex;
          slide.classList.toggle('is-active', isActive);
          slide.tabIndex = isActive ? 0 : -1;
        });

        details.forEach((detail, detailIndex) => {
          const isActive = detailIndex === activeIndex;
          detail.classList.toggle('is-active', isActive);
          detail.hidden = !isActive;
        });

        dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === activeIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-pressed', String(isActive));
        });
      };

      setActiveSlide(activeIndex);

      dots.forEach((dot, dotIndex) => {
        dot.addEventListener('click', () => setActiveSlide(dotIndex));
      });

      if (
        slides.length < 2
        || !Number.isFinite(interval)
        || interval <= 0
        || window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ) {
        return;
      }

      let isPausedByUser = false;
      let isPausedByInteraction = false;
      const pause = () => {
        isPausedByInteraction = true;
      };
      const resume = () => {
        isPausedByInteraction = false;
      };

      playbackToggle.addEventListener('click', () => {
        isPausedByUser = !isPausedByUser;
        playbackToggle.setAttribute('aria-pressed', String(isPausedByUser));
        playbackToggle.setAttribute('aria-label', isPausedByUser ? 'スライドを再生' : 'スライドを停止');
        playbackIcon.style.setProperty(
          '--main-visual-playback-icon',
          `url("${isPausedByUser ? playbackIcon.dataset.playIcon : playbackIcon.dataset.pauseIcon}")`
        );
      });

      media.addEventListener('mouseenter', pause);
      media.addEventListener('mouseleave', resume);
      carousel.addEventListener('focusin', (event) => {
        if (event.target.matches('[data-main-visual-slide], [data-main-visual-dot]')) {
          pause();
        }
      });
      carousel.addEventListener('focusout', (event) => {
        if (!event.relatedTarget?.matches('[data-main-visual-slide], [data-main-visual-dot]')) {
          resume();
        }
      });

      window.setInterval(() => {
        if (isPausedByUser || isPausedByInteraction) {
          return;
        }

        setActiveSlide((activeIndex + 1) % slides.length);
      }, interval);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
